import { LocalizationManager } from '@lib/localization';

/**
 * The languages customization content can be written in: the ones this interface itself is
 * translated into, read where the language picker in Settings reads them, so the two never
 * differ. A list of its own stood here once, fourteen languages typed in: some of them no
 * reader could set the interface to, and what it left out it left out for no reason.
 *
 * Only what is offered. The API accepts any language code of the common shape, and a
 * language a server enabled earlier or through the API stays in its set, is listed, named
 * and removable like the others, and is not offered again once removed.
 */
export const offeredLanguages = (): string[] => LocalizationManager.supportedLanguageCodes;

const nameIn = (code: string, language: string): string | undefined => {
  try {
    return new Intl.DisplayNames([language], { type: 'language' }).of(code);
  } catch {
    // A code or a reader's language the browser does not take: the caller falls back.
    return undefined;
  }
};

/**
 * A language by its own name, with the reader's name for it beside it where the two differ:
 * "Deutsch (German)", and plain "Deutsch" to a German reader. From the browser, so any
 * code is named and not only the offered ones; one the browser does not know is its code.
 */
export const languageName = (code: string, readerLanguage: string): string => {
  const own = nameIn(code, code);
  const readers = nameIn(code, readerLanguage);

  // Some languages write their own name small ("français"); a list reads better capitalised,
  // by that language's own rule.
  const title = own && own !== code ? own.charAt(0).toLocaleUpperCase(code) + own.slice(1) : undefined;

  if (!title) return readers && readers !== code ? readers : code;

  return readers && readers !== code && readers.toLocaleLowerCase(readerLanguage) !== title.toLocaleLowerCase(readerLanguage)
    ? `${title} (${readers})`
    : title;
};
